const rpcUrl = 'https://k8s.testnet.json-rpc.injective.network/',
    blockExplorers = 'https://testnet.blockscout.injective.network/'
export default {
    id: 1439,
    name: 'Injective Testnet',
    network: 'injective-testnet',
    nativeCurrency: {name: 'Injective', symbol: 'INJ', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'Injective Testnet explorer', url: blockExplorers},
        default: {name: 'Injective Testnet explorer', url: blockExplorers},
    },
    contracts: {},
}